import config from 'config';
import sfax from './sfax';
import graphqlRequest from './graphql'

const { esfDomain, loginDomain } = config;

export default {
    getLoupanSuggestions: (payload) => {
        return graphqlRequest({
            path: '/baseApi/loupanSuggest',
            query: payload
        }).then((res) => {
            const {
                data
            } = res
            const result = {
                code: 1
            }
            if (data) {
                result.code = '200'
                result.data = {
                    searchSuggest: data.otherDetails.projectSuggest
                }
            }
            return Promise.resolve(result)
        })
        // return sfax({
        // url: '/baseApi/loupanSuggest',
        // withCredentials: false,
        // data: payload
        // })
    },
    getRentSuggestions: payload => sfax({
        url: `${esfDomain}/beike/api/search/rent`,
        withCredentials: false,
        data: payload
    }),
    getEsfSuggestions: payload => sfax({
        url: `${esfDomain}/beike/api/search/sale`,
        withCredentials: false,
        data: payload
    }),
    getMsgAuthCode: payload => sfax({
        url: `${loginDomain}/captcha/secure/getMobileCaptcha`,
        withCredentials: false,
        data: payload,
        jsonp: true,
    }),
    getTxAuthCode: payload => sfax({
        url: `${loginDomain}/captcha/secure/tx/getMobileCaptcha?random=${Math.random()}`,
        withCredentials: false,
        data: payload,
        jsonp: true,
    }),
};



// WEBPACK FOOTER //
// ./src/model/api/suggest.js